import { OnInit, Component, ViewChild, ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { PharmacyGridData } from '../../DTO/pharmacy';
import { PharmacySearchModel } from '../../DTO/pharmacy-search';
import { PharmacyService } from 'src/app/services/pharmacyservice';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { VendorDropdownData } from '../../DTO/vendor';
import { VendorService } from 'src/app/services/vendorservice';

@Component({
  selector: 'app-pharmacy-search',
  templateUrl: './pharmacy-search.component.html',
  styleUrls: ['./pharmacy-search.component.css']
})
export class PharmacySearchComponent implements OnInit {
  
  displayedColumns: string[] = ['PharmacyID', 'PharmacyName', 'IsEnabled', 'EffectiveDate', 'TermDate', 'PetEnabled', 'BillingGroup', 'BillingRegion', 'Connectivity', 'edit'];
  dataSource: any;
  private pharmacyGridData?: PharmacyGridData;
  private pharmacySearchModel?: PharmacySearchModel ={ PharmacyName :'',EffectiveDate:'',TermDate:'',PetEnabled:'', PageNumber: 1, PageSize: 10 };
  isLoading: boolean = true;
  pageSizeOptions: number[] = [10, 20, 30, 100];
  pharmacyPagesize = 10;
  pharmacyPageNumber = 1;
  length: number | undefined;
  pharmacyFilter:string='';
  pharmacyGridCopy:any;
  vendorList:any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.LoadData();
    this.LoadVendors();
  }

  applyFilter(event: Event) {
  const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
  this.pharmacyFilter = filterValue;
  this.pharmacySearchModel.PharmacyName = filterValue;
  this.pharmacyPageNumber = 1;
  this.LoadData();
}

constructor(private pharmacyService: PharmacyService, private vendorService: VendorService, private toastr:ToastrService,
  private router: Router) {

}
ExportTOExcel() {
  this.pharmacySearchModel.PageNumber = 1;
  this.pharmacySearchModel.PageSize = this.length; // all items to be fetched

  this.pharmacyService.getPharmacyGrid(this.pharmacySearchModel).subscribe((response: any) => {
    const exportData = response.pharmacyData;

    if (exportData && exportData.length > 0) {
      const PharmacyArray = exportData.map((pharmacyModel: any) => ({
        "Pharmacy Chain Name": pharmacyModel.PharmacyName,
        "Activation Date": pharmacyModel.EffectiveDate,
        "Deactivation Date": pharmacyModel.TermDate,
        "Pharmacy Chain Active": pharmacyModel.IsEnabled,
        "Pet Transactions Enabled": pharmacyModel.PetEnabled,
        "Billing Group": pharmacyModel.BillingGroup,
        "Billing Region": pharmacyModel.BillingRegion
      }));

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(PharmacyArray);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Pharmacy');
      XLSX.writeFile(workbook, 'Pharmacy Chain.csv');
    } else {
      this.toastr.error("No Data to export");
    }
  }, error => {
    this.toastr.error("Failed to fetch data for export");
  });
}
 
LoadData() {
  this.isLoading = true;
  this.pharmacySearchModel.PageNumber = this.pharmacyPageNumber;
  this.pharmacySearchModel.PageSize = this.pharmacyPagesize;
  this.pharmacyService.getPharmacyGrid(this.pharmacySearchModel).subscribe(res => {
    this.pharmacyGridData = res;
    this.pharmacyGridCopy = JSON.parse(JSON.stringify(this.pharmacyGridData.pharmacyData))
    this.pharmacyGridData.pharmacyData.forEach((obj: any)=> {
      obj.NCPDPIDList=null;
    });
    this.dataSource = this.pharmacyGridData.pharmacyData;
    this.length = res.pagination.TotalItems;
    this.isLoading = false;
    this.dataSource.sort = this.sort;
    this.dataSource.filter = this.pharmacyFilter.trim().toLowerCase();
  },(error: any)=>{
    this.isLoading=false;
    this.toastr.error(error);
  });
}

onPageEvent(event: any) {
  this.pharmacyPagesize = event.pageSize;
  this.pharmacyPageNumber = event.pageIndex + 1;
  this.isLoading = true; // Show spinner while refreshing
  if(this.dataSource!=null){
    this.LoadData(); 
  }
}

public redirectToEdit = (id: string) => {
  this.router.navigate(['updatepharmacy/', id]);
}

onChange(event:any)
{
  //this.pharmacySearchModel.VendorId = this.get('MessageType')?.value;
  // if(this.section1.indexOf(event.source._elementRef.nativeElement.id)>=0)
  //   this.disableSection("section1");
  // else if(this.section2.indexOf(event.source._elementRef.nativeElement.id)>=0)
  //   this.disableSection("section2");
}

OnVendorChange(event:any)
{
  this.pharmacySearchModel.VendorId = event.value;
  this.LoadData();
}

LoadVendors() {
  this.vendorService.getVendors().subscribe(res => {
    this.vendorList = VendorDropdownData.vendorList;
  });
}

getConnectivityStatus(row: any): boolean {
  if (String(row.IsVendorConnectionEnabled).toLowerCase() === 'true') {
    const vendor = this.vendorList?.find(
      (v: any) => String(v.VendorId) === String(row.VendorId)
    );
    return vendor?.IsConnectivitySet?.toString().toLowerCase() === 'true';
  } else {
    return row.IsConnectivitySet?.toString().toLowerCase() === 'true';
  }
}

onSearchClick() {
  this.pharmacySearchModel.PharmacyName = this.pharmacyFilter;
  this.pharmacyPageNumber = 1; // Reset to first page
  this.LoadData();
}
}
